import LabeledTextArea from "components/labeledInput/LabeledTextArea";
import { formikConnect } from "utils/formikConnect";

export default formikConnect(LabeledTextArea);
